import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("polling");

  useEffect(() => {
    if (!sessionId) {
      setState("error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
      } catch (e) {
        // keep polling briefly
      }
      attempts += 1;
      if (attempts < 15) setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="min-h-[80vh] flex items-center justify-center px-4 pt-24 pb-16">
      <div className="max-w-lg w-full rounded-3xl bg-white border border-slateblue/15 p-10 text-center shadow-[0_32px_64px_-24px_rgba(16,42,67,0.2)]">
        {state === "polling" && (
          <>
            <Loader2 className="h-10 w-10 text-gold animate-spin mx-auto" />
            <h1 className="mt-6 font-serif text-3xl text-navy">Confirming your payment…</h1>
            <p className="mt-3 text-sm text-slateblue">This takes a few seconds.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-gold mx-auto" data-testid="payment-confirmed-icon" />
            <h1 className="mt-6 font-serif text-3xl text-navy" data-testid="payment-confirmed-heading">
              You're all set.
            </h1>
            <p className="mt-4 text-sm sm:text-base text-charcoal/75 leading-relaxed">
              Thank you — your Premium Travel Planning Kit is confirmed. Your download link is on its way to
              your inbox, and your receipt was emailed by Stripe.
            </p>
            <Link
              to="/"
              data-testid="success-home-button"
              className="mt-8 inline-flex items-center rounded-full bg-navy px-8 py-3.5 text-sm font-semibold text-ivory transition-colors duration-300 hover:bg-ocean"
            >
              Back to Venture &amp; Stay
            </Link>
          </>
        )}
        {(state === "error" || state === "timeout") && (
          <>
            <XCircle className="h-12 w-12 text-slateblue mx-auto" />
            <h1 className="mt-6 font-serif text-3xl text-navy">We couldn't confirm that payment</h1>
            <p className="mt-4 text-sm text-charcoal/75 leading-relaxed">
              If you completed checkout, your kit is still on its way — write to Ventureandstay@gmail.com and
              we'll sort it out.
            </p>
            <Link
              to="/planning-kit"
              data-testid="success-retry-button"
              className="mt-8 inline-flex items-center rounded-full border border-navy/25 px-8 py-3.5 text-sm font-semibold text-navy transition-colors duration-300 hover:border-gold hover:text-gold"
            >
              Back to the kit
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
